import { createContext, useContext, type ReactNode } from "react"
import { CHART_THEMES, type ChartTheme, type ChartThemeName } from "@/lib/chart/theme"

const ChartThemeContext = createContext<ChartTheme>(CHART_THEMES.dark)

/** Charts default to the dark terminal look; wrap light pages in `theme="light"`. */
export function ChartThemeProvider({ theme, children }: { theme: ChartThemeName; children: ReactNode }) {
  return <ChartThemeContext.Provider value={CHART_THEMES[theme]}>{children}</ChartThemeContext.Provider>
}

export function useChartTheme(): ChartTheme {
  return useContext(ChartThemeContext)
}

export function chartThemeName(value: string | undefined): ChartThemeName {
  return value === "light" ? "light" : "dark"
}
